/**
 * Cuero — premium floating header override.
 *
 * Default behavior (base.js):
 *   transparent while scrollY < heroHeight → solid after
 *
 * Override:
 *   - transparent ONLY at scrollY <= 10 (nearly instant solid on any scroll)
 *   - hover anywhere on the header also turns it solid
 *   - restores transparent when the mouse leaves AND we're still at the top
 *
 * base.js registers its own scroll listener that we can't remove. To win
 * deterministically regardless of script-execution order, we:
 *   1) Compute the state we want in applyState() (driven by isHovering
 *      and window.scrollY > THRESHOLD)
 *   2) Call applyState() on scroll, mouseenter, mouseleave
 *   3) Run a MutationObserver on the header's class attribute — if base.js
 *      (or anything else) changes the class to disagree with our desired
 *      state, we re-apply. applyState is idempotent via classList ops, so
 *      no infinite loop: a correct state causes zero mutations.
 */
(function () {
  function init() {
    var header = document.querySelector('.has-floating-header');
    if (!header) return;

    var floatingScheme = header.dataset.floatingColorScheme;
    var solidScheme = header.dataset.solidColorScheme;
    if (!floatingScheme || !solidScheme) return;

    var floatingLogo = document.querySelector('.floating-logo');
    var THRESHOLD = 10;
    var isHovering = false;
    var mobileMQ = window.matchMedia('(max-width: 749px)');

    function desiredSolid() {
      // Mobile always solid — no transparency on small screens.
      if (mobileMQ.matches) return true;
      return isHovering || window.scrollY > THRESHOLD;
    }

    function applyState() {
      var solid = desiredSolid();
      if (solid) {
        header.classList.remove(floatingScheme);
        header.classList.add(solidScheme);
        if (floatingLogo) floatingLogo.classList.remove('active');
      } else {
        header.classList.add(floatingScheme);
        header.classList.remove(solidScheme);
        if (floatingLogo) floatingLogo.classList.add('active');
      }
    }

    header.addEventListener('mouseenter', function () {
      isHovering = true;
      applyState();
    });

    header.addEventListener('mouseleave', function () {
      isHovering = false;
      applyState();
    });

    window.addEventListener('scroll', applyState, { passive: true });

    // Re-evaluate when crossing the mobile breakpoint
    if (mobileMQ.addEventListener) {
      mobileMQ.addEventListener('change', applyState);
    } else if (mobileMQ.addListener) {
      mobileMQ.addListener(applyState);
    }

    // Insurance: if anything else (base.js) changes the class list to
    // disagree with our desired state, re-apply. Idempotent classList ops
    // mean a no-op change produces no mutation, so no infinite loop.
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () {
        var solid = desiredSolid();
        var hasFloating = header.classList.contains(floatingScheme);
        var hasSolid = header.classList.contains(solidScheme);
        var correct = (solid && hasSolid && !hasFloating) ||
                      (!solid && hasFloating && !hasSolid);
        if (!correct) applyState();
      });
      observer.observe(header, { attributes: true, attributeFilter: ['class'] });
    }

    applyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
